import Vue from 'vue'
import axios from 'axios'

const initState = {
  config: null,
  loading: false,
  showPromoModal: false,
  popupVideo: null,
  domainType: null,
  isLocalhost: false
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    getConfigSuccess(state, data) {
      if (state.domainType === 'second') {
        data = {
          ...data,
          logo: null,
          logo_wide: null,
          logo_wide_white: null,
          name: null
        }
      }
      state.config = data
    },
    SET_PROMOMODAL_VALUE(state, value) { state.showPromoModal = value },
    SET_POPUPVIDEO(state, value) { state.popupVideo = value },
    SET_DOMAIN_TYPE(state, value) { state.domainType = value },
    SET_IS_LOCALHOST(state, value) { state.isLocalhost = value }
  },
  actions: {
    getConfig({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get('/config')
          .then((res) => {
            commit('getConfigSuccess', res.data.data)
            resolve(true)
          })
          .catch((err) => reject(err))
      })
    },
    getEditorData({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/editor-data', { params })
          .then((res) => resolve(res.data))
          .catch((err) => reject(err))
      })
    },
    setPromoModalValue({ commit }, value) {
      commit('SET_PROMOMODAL_VALUE', value)
    },
    setPopupVideo({ commit }, value) {
      commit('SET_POPUPVIDEO', value)
    },
    setDomainType({ commit }, value) {
      commit('SET_DOMAIN_TYPE', value)
    },
    setIsLocalhost({ commit }, value) {
      commit('SET_IS_LOCALHOST', value)
    }
  },
  getters: {
    whitelabelDomain(state) {
      return state.config && state.config.whitelabel ? state.config.whitelabel.domain : ''
    },
    whitelabelDomain2(state) {
      return state.config && state.config.whitelabel ? state.config.whitelabel.domain_2 : ''
    },
    config(state) { return state.config },
    loading(state) { return state.loading },
    showPromoModal(state) { return state.showPromoModal },
    popupVideo(state) { return state.popupVideo },
    domainType(state) { return state.domainType },
    isLocalhost(state) { return state.isLocalhost }
  }
}